<template>
  <div class="modal" :class="{ 'is-active': showModal }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Agregar a {{ table.type }} {{ table.name }}
        </p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <div class="control has-icons-left has-addons">
            <input
              type="number"
              min="0"
              step="1"
              pattern="[0-9]*"
              v-model="ammount"
              placeholder="0"
              @keyup.enter="addDue"
              @keyup.esc="close"
              class="input is-primary is-large has-text-right"
              autofocus
            />
            <span class="icon is-left">
              <span class="material-symbols-outlined">attach_money</span>
            </span>
          </div>
        </div>
        <p>Agregados a la mesa</p>
        <div>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Fecha y hora</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="h in due_history"
                v-bind:key="h.timestamp"
                :class="{ 'has-text-danger is-removed': h.is_deleted }"
              >
                <td>{{ formatDate(h.timestamp) }}</td>
                <td class="has-text-right">
                  {{ currency(h.due) }}
                  <button
                    :disabled="h.is_deleted"
                    class="delete"
                    aria-label="close"
                    @click="deleteDue(h)"
                    v-show="show_due_removal"
                  ></button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" class="has-text-right">
                  {{ currency(totalDue) }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="addDue">
          <span class="material-symbols-outlined">add</span>&nbsp;Agregar
        </button>
        <button class="button is-info" @click="close">
          <span class="material-symbols-outlined">close</span>&nbsp;Cancelar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import * as bulmaToast from "bulma-toast";

export default {
  name: "TableBucketModal",
  data() {
    return {
      showAdd: true,
      ammount: null,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },
    table: {
      type: Object,
    },
    due_history: {
      type: Array,
    },
  },
  computed: {
    totalDue() {
      return this.due_history
        .filter((h) => !h.is_deleted)
        .reduce((a, h) => a + h.due, 0);
    },
    show_due_removal() {
      return this.dueHistoryLength() - 1 > 0;
    },
  },
  methods: {
    addDue() {
      if (parseFloat(this.ammount) <= 0) {
        bulmaToast.toast({
          message: "El valor debe ser mayor a 0",
          type: "is-danger",
          position: "bottom-right",
        });
        return;
      }
      if (this.ammount) {
        this.$emit("addDue", this.ammount);
      } else {
        this.$emit("closeModal");
      }
    },
    deleteDue(due) {
      this.$emit("deleteDue", due);
    },
    close($event) {
      this.$emit("closeModal", $event);
    },
    currency(val) {
      let cur = Intl.NumberFormat("es-CO");
      return `$ ${cur.format(val)}`;
    },
    formatDate(date) {
      return format(date, "p");
    },
    dueHistoryLength() {
      return this.due_history.filter((dh) => !dh.is_deleted).length;
    },
  },
  mounted() {
    let input = document.querySelector("[autofocus]");
    if (input) {
      input.focus();
    }
  },
};
</script>

<style scoped>
.modal-background {
  background-color: rgba(10, 10, 10, 0.4);
}
.is-removed {
  text-decoration: line-through;
}
</style>
